import React, { Fragment } from 'react';

const ContentCard = ({ data }) => {
	return (
		<Fragment>
			{data ? (
				<div className='content-card-outer'>
					<div className='content-card-inner'>
						<div className='cc-mobile md:hidden'>
							<a
								href={data.link}
								target='_blank'
								rel='noopener noreferrer'
								title={data.title}
								className={`${
									data.link ? '' : 'pointer-events-none'
								}`}
							>
								<img
									src={data.imageMobile}
									alt={data.imageAlt}
								/>
							</a>
						</div>

						<div className='cc-desktop hidden md:block'>
							<a
								href={data.link}
								target='_blank'
								rel='noopener noreferrer'
								title={data.title}
								className={`${
									data.link ? '' : 'pointer-events-none'
								}`}
							>
								<img
									src={data.imageDesktop}
									alt={data.imageAlt}
								/>
							</a>
						</div>
					</div>
				</div>
			) : (
				<div className='cc-no-data'>
					<p>No data</p>
				</div>
			)}
		</Fragment>
	);
};

export default ContentCard;
